/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_up': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M254.7 172L128.2 45.5 1.7 172l38 38 88.5-88.5 88.5 88.5z"/>'
  }
})
